// extracted by mini-css-extract-plugin
module.exports = {"section":"VideosMock_section__V1n8W","list":"VideosMock_list___ORyN","upload":"VideosMock_upload__vzqpm","placeholder":"VideosMock_placeholder__XSXQs"};